'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/**
 * Mount-time page entrance animation.
 *
 * Adds the `page-transition-in` class to `<html>` for 350ms so the route can
 * play a CSS enter transition, then removes it. Pairs with the
 * `page-transition-out` class applied by the outgoing route.
 *
 * Shared by the auth pages (login, register, reset-password/request) so the
 * identical useEffect isn't copy-pasted across each page — see PIERRE-1863.
 */
export function usePageTransition() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
}
function _temp() {
  const root = document.documentElement;
  root.classList.remove("page-transition-out");
  root.classList.add("page-transition-in");
  const timer = setTimeout(() => {
    root.classList.remove("page-transition-in");
  }, 350);
  return () => clearTimeout(timer);
}